module.exports = __webpack_public_path__ + "img/truck_10.551162c4.svg";